import { isPromise } from "./_internal/utils.js";
/**
 * @internal
 */
const pipe1 = (a, f) => {
    return isPromise(a) ? a.then(f) : f(a);
};
export default pipe1;
//# sourceMappingURL=pipe1.js.map